import type { ProdutoCatalogo } from "@/api"
import { calcularItemPesado, formatarPesoKg } from "./balanca-item"
import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography, useMediaQuery, type Theme } from "@mui/material"
import CardProduto from "@/components/catalogo-kiosk/card-produto"
import CloseIcon from '@mui/icons-material/Close'
import ScaleIcon from '@mui/icons-material/Scale'

export interface ProdutoPesavel {
    produto: ProdutoCatalogo
    cor: string | null
}

interface DialogSelecaoBalancaProps {
    open: boolean
    pesoKg: number | null
    produtos: ProdutoPesavel[]
    enviando: boolean
    onSelecionar: (produto: ProdutoCatalogo) => void
    onClose: () => void
}

function DialogSelecaoBalanca({ open, pesoKg, produtos, enviando, onSelecionar, onClose }: DialogSelecaoBalancaProps): JSX.Element {
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isMobile}
            fullWidth
            maxWidth="md"
            slotProps={{
                paper: {
                    sx: { borderRadius: isMobile ? 0 : 4 }
                }
            }}
        >
            <DialogTitle sx={{ pr: 7 }}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <ScaleIcon fontSize="large" />

                    <Stack>
                        <Typography variant="h5" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>
                            O que você está pesando?
                        </Typography>

                        {pesoKg != null && (
                            <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>
                                Peso: {formatarPesoKg(pesoKg)}
                            </Typography>
                        )}
                    </Stack>
                </Stack>

                <IconButton onClick={onClose} sx={{ position: 'absolute', top: 12, right: 12 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers sx={{ position: 'relative' }}>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1.5,
                        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                        opacity: enviando ? 0.5 : 1,
                        pointerEvents: enviando ? 'none' : 'auto',
                    }}
                >
                    {produtos.map(({ produto, cor }) => {
                        const total = pesoKg != null ? calcularItemPesado(produto, pesoKg).valorTotal : produto.valor

                        return (
                            <CardProduto
                                key={produto.id}
                                produto={produto}
                                cor={cor}
                                quantidade={0}
                                precoExibido={total}
                                onSelecionar={onSelecionar}
                            />
                        )
                    })}
                </Box>

                {enviando && (
                    <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress />
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default DialogSelecaoBalanca
